export default "__VITE_PUBLIC_ASSET__9a3d58c7__"